// client/src/components/volunteers/VolunteerSignupPage.jsx
//
// /volunteer/:token — the link in a volunteer's confirmation and reminder
// emails (Roadmap Phase 5.2). Shows their shift and lets them say they can't
// make it. No sign-in; the token is signed by the server.

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getVolunteerSignup, cancelVolunteerSignup, errorText } from '../../services/volunteersApi';
import '../donations/Donations.css';

export default function VolunteerSignupPage() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [signup, setSignup] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getVolunteerSignup(token)
      .then((r) => setSignup(r.signup))
      .catch((err) => setError(errorText(err, t('volunteers.public.invalid', 'This link isn’t valid.'))));
  }, [token, t]);

  const cancel = async () => {
    if (!window.confirm(t('volunteers.public.confirm', 'Let {{org}} know you can’t make this shift?', { org: signup.organization }))) return;
    setBusy(true); setError('');
    try {
      await cancelVolunteerSignup(token);
      setSignup((s) => ({ ...s, status: 'canceled' }));
    } catch (err) {
      setError(errorText(err, t('volunteers.public.cancelError', 'That didn’t go through. Try again, or contact the organization.')));
    } finally { setBusy(false); }
  };

  return (
    <main className="dn-public">
      <div className="dn-shell">
        <section className="dn-card">
          <h1 className="dn-title">{t('volunteers.public.title', 'Your volunteer shift')}</h1>
          {!signup && !error && <p>{t('common.loading', 'Loading…')}</p>}
          {error && <p className="dn-error" role="alert">{error}</p>}
          {signup && (
            <div className="dn-form">
              <p className="dn-org">{signup.organization} · {signup.event}</p>
              <p className="dn-desc"><strong>{signup.role}</strong><br />{signup.when}{signup.location && ` · ${signup.location}`}</p>
              {signup.description && <p className="dn-desc">{signup.description}</p>}
              {signup.status === 'canceled' && <p className="dn-ok" role="status">{t('volunteers.public.canceled', 'You’re off this shift. Thanks for letting us know.')}</p>}
              {signup.status === 'signed_up' && !signup.past && (
                <>
                  <p className="dn-ok" role="status">{t('volunteers.public.confirmed', 'You’re signed up, {{name}}. We’ll remind you the day before and an hour before.', { name: String(signup.name).split(' ')[0] })}</p>
                  <button type="button" className="dn-secondary" onClick={cancel} disabled={busy}>{t('volunteers.public.cancel', 'I can’t make it')}</button>
                </>
              )}
              {['checked_in', 'completed'].includes(signup.status) && <p className="dn-ok" role="status">{t('volunteers.public.thanks', 'Thank you for volunteering!')}</p>}
            </div>
          )}
        </section>
      </div>
    </main>
  );
}
